module.exports = __webpack_public_path__ + "img/neu.172d072d.svg";